export const INCREASE_UTP = [
  {
    text: 'Прогнозируем количество дополнительных уникальных показов, которое получит объявление в поиске и рекомендациях',
    imageClass: 'human',
  },
  {
    text: 'Оцените точный эффект от продвижения в прозрачной статистике показов объявлений',
    imageClass: 'lightning',
  },
];
